import { postAPI } from "../../api/api";
import { REACT_APP_CANDIDATE_FRELLANCER, REACT_APP_JOB } from "../../utils/common";


export async function updateCandidateStatus(data : any){
    const Details = postAPI( REACT_APP_CANDIDATE_FRELLANCER + '/updatecandidatestatus', data)
    // REACT_APP_JOB + '/api/updateCandidatePositionStatus', body
    return Details
}

// 2 - shortlist
// 3 - rejected
